<template>
    <v-container>
        <h1>Class - {{ characterClass.name }}</h1>
        <v-card>
            <v-card-text>
                <div>Perks</div>
                <div v-for="(perk, perkIndex) in characterClass.perks" :key="perkIndex">
                    {{ perk.amount }} - {{ perk.description }}
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn @click="$router.push({name: 'character-classes'})">
                    Go Back
                </v-btn>
                <v-btn @click="$router.push({name: 'add-perk-to-character-class', params: {characterClassId: characterClass.id}})">
                    Add Perk
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
  import CharacterClassService from "../services/CharacterClassService";

  export default {
    data: () => ({
      characterClass: {
        id: null,
        name: null,
        perks: []
      }
    }),

    created() {
      this.viewCharacterClasses();
    },

    methods: {
      viewCharacterClasses() {
        CharacterClassService.view(this.$route.params.characterClassId)
          .then(response => {
            this.characterClass = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>